import l10n from "diy/util/l10n";

import ActionExploreIcon from "material-ui/svg-icons/action/explore";

import Type from "../definitions/Type";
import {NotificationConfig} from "../definitions/Config";

export default {
    type: Type.GUIDANCE,

    testId: "guidance",
    trackingId: "GuidanceNotification",

    title: l10n("guidance.notification.title"),
    content: l10n("guidance.notification.content"),
    icon: ActionExploreIcon,

    mainAction: {
        testId: "guidance-start",
        label: l10n("guidance.notification.start"),
        onClick: () => {
            diy.editor.guidance.start();
        }
    },

    bubbleOptions: {
        autoHide: false
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/Guidance.ts
 **/